export default __webpack_public_path__ + "static/media/centris_data_transfer_modal_fr.05e1a2ca.png";